<script>
    import * as Utils from '@js/modules/utils';

    const {
        selected,
        data = 0,
        unitName,
        type,
        onUnitChange
    } = $props();

    const HEIGHT_OFFSET = window.innerWidth < window.settings.medium_screen ? 36 : 44;
    let _handleScrollChange;

    let position = selected ? -(selected - 1) * HEIGHT_OFFSET : 0;
    let offset = 0;
    let dragging = false;

    let itemWrapper;
    let previousY;

    let scrollable = $state(true);

    const wheel = (node, options) => {
        let {scrollable} = options;

        const handler = (event) => {
            if (!scrollable) {
                event.preventDefault();
            }
        };

        node.addEventListener('wheel', handler, {passive: false});

        return {
            update(opt) {
                scrollable = opt.scrollable;
            },
            destroy() {
                node.removeEventListener('wheel', handler, {passive: false});
            }
        };
    };

    const touch = (node, options) => {
        let {scrollable} = options;

        const handler = (event) => {
            if (!scrollable) {
                event.preventDefault();
            }
        };

        node.addEventListener('touchstart', handler, {passive: false});
        node.addEventListener('touchmove', handler, {passive: false});
        node.addEventListener('touchend', handler, {passive: false});

        return {
            update(opt) {
                scrollable = opt.scrollable;
            },
            destroy() {
                node.removeEventListener('touchstart', handler, {passive: false});
                node.removeEventListener('touchmove', handler, {passive: false});
                node.removeEventListener('touchend', handler, {passive: false});
            }
        };
    };

    const toTwoDigitString = (number) => {
        if (number < 10) {
            return `0${number}`;
        }
        return `${number}`;
    };

    const setPosition = (isWheel = false) => {
        if (isWheel) {
            itemWrapper.style.cssText = `
      will-change: 'transform';
      transition: transform ${Math.abs(offset) / 100 + 0.2}s;
      transform: translateY(${position}px)
    `;
        } else {
            itemWrapper.style.cssText = `
      transform: translateY(${position}px)
    `;
        }
    };

    const onMouseMove = (event) => {
        const clientY = event.touches ? event.touches[0].clientY : event.clientY;
        offset = clientY - previousY;

        const maxPosition = -data.length * HEIGHT_OFFSET;
        const _position = position + offset;
        position = Math.max(maxPosition, Math.min(HEIGHT_OFFSET, _position));
        previousY = event.touches ? event.touches[0].clientY : event.clientY;

        setPosition();
    };

    const onMouseUp = (isWheel = false) => {
        const maxPosition = -(data.length - 1) * HEIGHT_OFFSET;
        const rounderPosition = Math.round((position + offset * 5) / HEIGHT_OFFSET) * HEIGHT_OFFSET;
        const finalPosition = Math.max(maxPosition, Math.min(0, rounderPosition));

        dragging = false;
        position = finalPosition;

        window.removeEventListener('mousemove', onMouseMove);
        window.removeEventListener('mouseup', onMouseUp);
        window.removeEventListener('touchmove', onMouseMove);
        window.removeEventListener('touchend', onMouseUp);

        setPosition(isWheel);
        onUnitChange(type, -finalPosition / HEIGHT_OFFSET);

        setTimeout(() => scrollable = true, 1);
    };

    const onMouseDown = (event) => {
        // event.preventDefault();

        scrollable = false;

        previousY = event.touches ? event.touches[0].clientY : event.clientY;
        dragging = true;

        window.addEventListener('mousemove', onMouseMove);
        window.addEventListener('mouseup', onMouseUp);
        window.addEventListener('touchmove', onMouseMove);
        window.addEventListener('touchend', onMouseUp);
    };

    const _initScrollThrottling = (throttleTime) => {
        _handleScrollChange = Utils.throttle((event) => {
            if (event.deltaY > 0) {
                position -= HEIGHT_OFFSET;
            }
            if (event.deltaY < 0) {
                position += HEIGHT_OFFSET;
            }
        }, throttleTime);
    };

    const onWheel = (event) => {
        // event.preventDefault();

        scrollable = false;

        if (!_handleScrollChange) {
            const isTouchPad = event.wheelDeltaY ? event.wheelDeltaY === -3 * event.deltaY : event.deltaMode === 0;
            _initScrollThrottling(isTouchPad ? 150 : 30);
        }

        _handleScrollChange(event);

        onMouseUp(true);
    };

    $effect(() => {
        setPosition();
    });

    $effect(() => {
        const selectedPosition = -(selected - 1) * HEIGHT_OFFSET;
        if (!dragging && position !== selectedPosition) {
            position = selectedPosition;
            setPosition();
        }
    });
</script>

<svelte:window use:wheel={{scrollable}}
               use:touch={{scrollable}}/>

<div class="touch-date-switcher"
     style="--height-offset:{HEIGHT_OFFSET}px;"
     role="timer"
     onmousedown={onMouseDown}
     ontouchstart={onMouseDown}
     onwheel={onWheel}>
    <ul bind:this={itemWrapper}
        class="touch-date-container">
        {#each data as item (item)}
            <li>
                {toTwoDigitString(item)}
                {#if unitName}
                    <div class="touch-date-unit-name">{window.innerWidth < window.settings.medium_screen ? unitName[0] : unitName}</div>
                {/if}
            </li>
        {/each}
    </ul>
</div>
